import React from "react";
import "./Amenities.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

import amt1 from "../../assets/imgs/amt1.jpg";
import amt2 from "../../assets/imgs/amt2.jpg";
import amt3 from "../../assets/imgs/amt3.jpg";
import amt4 from "../../assets/imgs/amt4.jpg";
import amt5 from "../../assets/imgs/amt5.jpg";
import amt6 from "../../assets/imgs/amt6.jpg";

export default function Amenities() {
  const amenities = [
    { img: amt1, title: "Cricket Court" },
    { img: amt2, title: "Park" },
    { img: amt3, title: "Kids Play Area" },
    { img: amt4, title: "Yoga" },
    { img: amt5, title: "Basketball Court" },
    { img: amt6, title: "Tennis Court" },
  ];

  const scrollToContact = () => {
    const section = document.getElementById("contact");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="amnt" id="amenities">
      <div className="maxW">
        <h2 className="amnHd">Amenities</h2>

        <div className="amtTp">
          <p>
            Arvind Plots Vadodara Discover an Active Life, Luxury Amenities to
            Explore Everyday
          </p>

          <button
            type="button"
            className="amnBtn"
            onClick={scrollToContact}
          >
            Contact us
          </button>
        </div>
      </div>

      <div className="amnSwiper">
        <Swiper
          modules={[Autoplay]}
          slidesPerView={4.3}
          spaceBetween={25}
          loop
          autoplay={{
            delay: 1800,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          grabCursor
          breakpoints={{
            1200: { slidesPerView: 3.8, spaceBetween: 22 },
            992: { slidesPerView: 4.8, spaceBetween: 22 },
            768: { slidesPerView: 2.8, spaceBetween: 18 },
            480: { slidesPerView: 1.8, spaceBetween: 20 },
            320: { slidesPerView: 1, spaceBetween: 20 },
          }}
        >
          {amenities.map((a) => (
            <SwiperSlide key={a.title}>
              <div className="amnBox">
                <img src={a.img} alt={a.title} />
                <h4>{a.title}</h4>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
